import { sentenceItem } from "../models/interfaces";

export const redlineNotes = (sentence: sentenceItem) => {
  let returnString = '';
  for (const entry of sentence.redlineLog) {
    const localEntry = `[${entry.date ? entry.date.toString() : ''}] ${
      entry.user
    } - ${entry.action ? 'redlined' : 'redline removed'} \n`;
    returnString = `${returnString} ${localEntry}`;
  }
  return returnString;
};
